module.exports = __webpack_public_path__ + "assets/img/29_238.756086b4.jpg";